<template>
  <div v-if="googleAuth || facebookAuth" class="authx-form--socials">
    <div class="divider">
      <div>
        <p>OR</p>
      </div>
    </div>
    <el-row type="flex" :gutter="10">
      <el-col v-if="googleAuth" :span="12" class="el-input">
        <div
          class="access google"
          :class="{ preview: preview }"
          @click="socialLogin(socialAuthTypes.GOOGLE.VALUE)"
          v-loading.lock="socialType === socialAuthTypes.GOOGLE.VALUE"
          :style="{
            backgroundColor: colors.primary
              ? `${colors.primary}30`
              : 'transparent'
          }"
        >
          <img :src="getImage('google.svg')" alt="G" />
          <p>{{ label }} {{ socialAuthTypes.GOOGLE.NAME }}</p>
        </div>
      </el-col>
      <el-col v-if="facebookAuth" :span="12" class="el-input">
        <div
          class="access facebook"
          :class="{ preview: preview }"
          @click="socialLogin(socialAuthTypes.FACEBOOK.VALUE)"
          v-loading.lock="socialType === socialAuthTypes.FACEBOOK.VALUE"
          :style="{
            backgroundColor: colors.primary
              ? `${colors.primary}30`
              : 'transparent'
          }"
        >
          <img :src="getImage('facebook.svg')" alt="G" />
          <p>{{ label }} {{ socialAuthTypes.FACEBOOK.NAME }}</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiConstants from "@/apiConstants";
import { redirectToSocialLogin } from "@/lib/utils";

export default {
  name: "FormSocial",
  props: {
    label: {
      type: String,
      default: ""
    },
    googleAuth: {
      type: [Boolean, Number],
      default: 0
    },
    facebookAuth: {
      type: [Boolean, Number],
      default: 0
    },
    sessionToken: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      socialType: "",
      socialAuthTypes: apiConstants.SOCIAL_AUTH_TYPES
    };
  },

  inject: ["preview"],

  computed: {
    preview() {
      return this.preview;
    }
  },

  methods: {
    socialLogin(type) {
      if (this.socialType || this.radiusUser) {
        this.$message.error("This is only for preview!");
        return;
      }

      this.socialType = type;
      localStorage.setItem("vendor-social-type", type);

      redirectToSocialLogin(this.$http, type, this.sessionToken)
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.socialType = "";
            this.handleErrors(resData);
          } else {
            localStorage.setItem("vendor-session-token", this.sessionToken);
            window.location = resData.redirect_url;
          }
        })
        .catch(err => {
          this.socialType = "";
          this.notification("Error", err.message, "danger");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.authx-form--socials {
  .divider {
    height: 2px;
    background: #eee;
    width: 100%;
    margin: 20px auto;
    position: relative;

    div {
      padding: 5px 10px;
      position: absolute;
      top: -15px;
      left: 50%;
      transform: translateX(-50%);
      background: #fff;
    }

    p {
      font-weight: 600;
    }
  }

  .access {
    cursor: pointer;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid rgba(var(--ra-primary), 0.4);
    margin-bottom: 10px;

    &.preview {
      pointer-events: none;
    }

    img {
      height: 18px;
      width: auto;
      margin-right: 15px;
    }

    p {
      color: var(--ra-grey-tertiary);
      font-size: 12px;
    }
  }
}
</style>
